import template from './index.html'
import { fapp } from '../../fapp'

const pageLogin = () => {
  return {
    transitionEffect: false,
    title: 'ВХОД',
    login: '',
    password: '',
    error: '',
    async init() {
      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
    },
    async onLogin() {
      this.error = ''
      if (this.login == '' || this.password == '') {
        this.error = 'Логин и пароль не могут быть пустыми.'
        return
      }

      try {
        const { user, accessToken } = await fapp.authenticate({
          strategy: 'local',
          login: this.login,
          password: this.password
        })
      } catch (e) {
        this.error = 'Неверный логин или пароль.'
        //this.error = 'Ошибка сервера, попробуйте повторить действие позже.'
      }
    },
    openMenu() {
      this.app.showMenu = true
    }
  }
}

export { pageLogin }
